<template>
  <b-modal no-fade v-model="dialog.show" size="sm" :id="`modal-psp-${uniqueId}`"
           :hide-footer="true" centered @close="onDialogClose"
           no-close-on-backdrop
  >
    <template #modal-title>
      {{ (isNewPsp ? $t('operations.add') : $t('operations.edit')) + ' PSP' }}
    </template>

    <div v-if="loading !== true && error == null">
      <b-form @submit.prevent="onSubmit">
        <b-form-group v-bind:label="$t('columns.name')">
          <b-form-input v-model="psp.name" required autofocus/>
        </b-form-group>

        <b-form-group v-bind:label="$t('columns.active')">
          <b-form-checkbox v-model="psp.active" switch/>
        </b-form-group>

        <b-form-group v-bind:label="$t('columns.sortOrder')"
                      :description="$t('psp.sortOrderHint')">
          <b-form-input v-model.number="psp.sortOrder" type="number" min="0"/>
        </b-form-group>

        <hr/>
        <div class="text-right">
          <b-button variant="outline-secondary" class="mr-1" @click="closeModal">
            {{ $t('operations.cancel') }}
          </b-button>
          <b-button variant="primary" type="submit" :disabled="submitting">
            <b-spinner small v-if="submitting"></b-spinner>
            {{ $t('operations.save') }}
          </b-button>
        </div>
      </b-form>
    </div>
    <div class="text-center" v-else-if="loading !== true && error != null">
      <b-alert show variant="danger">
        <i class="fa-sharp fa-solid fa-triangle-exclamation"></i>
        {{ error }}
      </b-alert>
    </div>
    <div class="text-center" v-else>
      <b-spinner>{{ $t('operations.loading') }}</b-spinner>
    </div>
  </b-modal>
</template>

<script>
import mixinBase from '@/components/mixin/mixinBase'
import mixinNotifications from '@/components/mixin/mixinNotifications'
import { mapActions } from 'vuex'
import Psp from '@/model/psp/Psp'

export default {
  name: 'pspModal',
  components: {},
  mixins: [mixinBase, mixinNotifications],
  data: () => ({
    dialog: {
      show: false,
    },
    uniqueId: 0,
    loading: true,
    submitting: false,
    error: null,
    id: null,
    isNewPsp: false,
    psp: Psp()
  }),
  created() {
    this.uniqueId = this._uid
  },
  methods: {
    ...mapActions('psp', ['getPspById', 'createPsp', 'updatePsp']),
    showModal(id) {
      this.id = id
      this.loading = true
      this.dialog.show = true
      this.isNewPsp = this.id == null || this.id === 0
      if (!this.isNewPsp) {
        this.refreshData()
      } else {
        this.psp = Psp()
        this.error = null
        this.loading = false
      }
    },
    closeModal() {
      this.dialog.show = false
      this.psp = Psp()
      this.onDialogClose()
    },
    onDialogClose() {
      this.id = null
    },
    refreshData() {
      let $this = this
      this.getPspById(this.id)
          .then(psp => {
            $this.psp = psp
            $this.error = null
            $this.loading = false
          }, err => {
            $this.error = $this.getErrorDescription(err)
            $this.loading = false
          })
    },
    onSubmit() {
      let $this = this
      this.submitting = true
      let operation = this.isNewPsp
          ? this.createPsp({ psp: this.psp })
          : this.updatePsp({ id: this.id, psp: this.psp })
      operation
          .then(() => {
            $this.showSuccessNotification($this.$t(
                $this.isNewPsp ? 'globalMessages.addDataSuccess' : 'globalMessages.updateDataSuccess',
                { system: $this.psp.name }
            ))
            $this.closeModal()
            $this.$emit('submitted')
          })
          .catch(err => {
            $this.showErrorNotification($this.$t(
                $this.isNewPsp ? 'globalMessages.addDataError' : 'globalMessages.updateDataError',
                { system: $this.psp.name }
            ), $this.getErrorDescription(err))
          })
          .finally(() => {
            $this.submitting = false
          })
    },
  }
}
</script>

<style scoped>

</style>
